import React from 'react'
import { TimelineData } from '../../File'
import CodeBlock from './CodeBlock'

export default function Timeline() {
    
    return (
        <ul className="timeline timeline-snap-icon max-md:timeline-compact timeline-vertical mt-32 px-[20vw] max-sm:px-[5vw]">
            {TimelineData.map((item) => (
                <li key={item.id}>
                    <div className="timeline-middle text-primary">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            className="h-5 w-5">
                            <path
                                fillRule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                                clipRule="evenodd" />
                        </svg>
                    </div>
                    <div className={`${item.id % 2 === 0  ? 'timeline-start md:text-end' : 'timeline-end md:text-start'} imp-mb-52`}>
                        <time className="font-mono italic">#{item.id}</time>
                        <div className="text-lg font-black">{item.title}</div>
                        <div>{item.desc}</div>
                        <div>
                            <div className={`w-full flex mt-5 ${item.id % 2 === 0 ? 'justify-end' : 'justify-start'} max-sm:justify-start`}>
                                <CodeBlock code={item.example} language="css" />
                            </div>
                        </div>
                    </div>
                    <hr />
                </li>
            ))}
        </ul>
    )
}
